<template lang="pug">
div
  template(v-if="!pageLoading")
    .gbox(ref="container")
      #preloader(v-if="gameLaunching || favListAction")
        #loader
      //- .d-flex.align-items-center.position-relative.search-bar
        input.form-control(type="text" v-model="searchinput" placeholder="Search")
        img.position-absolute.search-img(src="assets/img/search-icon.png")
      div.ggl-box(v-if="!pageLoading")
        template(v-if="listToDisplay.length > 0")
          .ggl(v-for="game in filteredList()")
            img.fav-icon.pointer(:src="getImg(game.game_code)" @click="favAction(game.game_platform,game.game_code,game.game_name,game.game_type,'assets/img/game_icon/SEXYBCRT/'+game.game_code+'.png')")
            a(href="javascript:void(0)" @click='launchGame(game.game_code, game.game_name)')
              img.img-fluid(:src="'assets/img/game_icon/SEXYBCRT/'+game.game_code+'.png'")
              span {{game.game_name}} 
        //- #end-of-list(v-show='((page !== items.length - 1) || !loading)' ref='end-of-list')
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      temp:[],
      items:[],
      offList:[],
      // searchinput: "",
      favListAction: false
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "ph":
          return "ph"
        default :
          return "en"
      }
    },
    favList(){
			return this.$store.getters.getFavlist.filter((x)=>x.game_type === "LIVE")
		}
  },
  destroyed(){
    // window.removeEventListener('scroll', this.loadItems)
  },
  mounted(){
    window.scroll(0,0)
    this.getProviderGameOfflist()
    // var vm = this
    // window.addEventListener('scroll', this.loadItems)
    // $("*").scroll(function(e) {
    //   vm.loadItems()
    // });
  },
  methods:{
    getProviderGameOfflist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "SEXYBCRT"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
							this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.getGameList()
			}
    },
    getGameList(){
      var vm = this
      this.pageLoading = true
			var url = config.getAwcList()
      this.$http.post(url, {
        "platform": "SEXYBCRT",
        "gametype": "LIVE"
      }).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              this.gameList = successResponse.data
              this.listToDisplay = [].concat(
                this.gameList.filter(obj1 => this.offList.every(obj2 => obj1.KeyName !== obj2.game_code)),
                this.offList.filter(obj2 => this.gameList.every(obj1 => obj2.game_code !== obj1.KeyName))
              )
              // this.items = _.chunk(updateList, 30);
              // this.listToDisplay = this.items[0]
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    // loadItems(){
    //   if(this.page === this.items.length - 1) return
        
    //   const element = this.$refs["end-of-list"] //this.endOfList;
    //   if(!element) return
      
    //   const position = element.getBoundingClientRect();
    //   // checking whether fully visible
    //   if((position.top >= 0 && position.bottom <= window.innerHeight  ) && !this.loading) {
    //       this.loading = true
    //       this.page++
    //       setTimeout(() => {
    //           this.listToDisplay = (this.listToDisplay).concat(this.items[this.page])
    //           this.loading = false
    //           this.loadItems()
    //       }, 500);
    //   }
    // },
    launchGame(game, name){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let lang_code = "en"
        let provider = "SEXYBCRT"
        let game_type = "LIVE"
        let game_name = name
        this.$store
          .dispatch("user/launchAwc", { player_id, auth_token,game_code, lang_code, provider, game_type, game_name })
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {
              vm.gameLaunching = false        
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                    
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("/deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				$("#logModal").modal("show")
			}
    },
    filteredList(){
      return this.listToDisplay.filter((game) =>
        game.game_name.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    },
    favAction(provider,game,name,type,img){
      if (this.sessionToken) {
        if(this.favList.some(obj=> obj.game_code === game)){
          this.removeFav(provider, game)
        }else{
          this.addFav(provider,game,name,type,img)
        }
      }else{
        $("#logModal").modal("show")
      }
    },
    addFav(provider,game,name,type,img){
      if (this.sessionToken) {
        this.favListAction = true
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let game_name = name
        let provider_code = provider
        let game_type = type
        let img_url = img
        this.$store
          .dispatch("user/addFav", { account_id, auth_token,game_code, game_name, provider_code, game_type, img_url })
          .then(response => {
            if (response.success == true) {
							// console.log(response)
              this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
    },
    removeFav(provider, game){
			if (this.sessionToken) {
        this.favListAction = true
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let provider_code = provider
        this.$store
          .dispatch("user/removeFav", { account_id, auth_token,game_code, provider_code })
          .then(response => {
            if (response.success == true) {
              // this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
		},
    getImg(code){
      if(this.favList.some(obj=> obj.game_code === code)){
        return "assets/img/fav-s.png"
      }else{
        return "assets/img/fav.png"
      }
      // 
    },
    getFavlist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getFavlist", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
							// console.log(response)
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
  }
}
</script>